const book = "_275b1frctij";
const image = "_275i142z79b";
const chevron = "_275cz9or86";
const heartButton = "_275hslc7xa";

export { book, chevron, heartButton, image };
import "./_book-card.style.linaria.module.css";
//# sourceMappingURL=_book-card.style.js.map
